/**
 * Template for Hébergement filter
 * @param {Object} facette - filter[facetteName]
 * @param {Object} filtreSpecial - filter.housingspec
 * @param {Object} wordings - SEARCH_SCRIPTS.WORDING_SEARCH
 * @param {string} tab - newHousingType_tab
 * @return {string} - HTML content
 */
export const housingTpl = function (facette, filtreSpecial, wordings, tab) {
  let htmlFacette = '';
  let htmlContainerFilter = '';

  // Grouping data by hosting group
  const arrListHebergement = _.groupBy(facette.values, 'keyGrouping');
  const arrFilterContent = {
    'COTTAGE': {
      key: 'COTTAGE',
      htmlContainer: '',
      label: wordings.facette_new_housing_cottage_tab_label
    },
    'SPECIALS': {
      key: 'SPECIALS',
      htmlContainer: '',
      label: wordings.facette_new_housing_specials_tab_label
    },
    'HOTELAPPARTEMENT': {
      key: 'HOTELAPPARTEMENT',
      htmlContainer: '',
      label: wordings.facette_new_housing_apphotel_tab_label
    },
    'MAISON': {
      key: 'MAISON',
      htmlContainer: '',
      label: wordings.facette_new_housing_maison_tab_label
    },
    'HOTEL': {
      key: 'HOTEL',
      htmlContainer: '',
      label: wordings.facette_new_housing_hotel_tab_label
    }
  };
  const arrFilterSpecialContent = {
    'ANIMALS': {
      key: 'ANIMALS',
      htmlContainer: '',
      label: wordings.facette_label_housingSpecAnimals
    },
    'PMR': {
      key: 'PMR',
      htmlContainer: '',
      label: wordings.facette_label_housingSpecPmr
    }
  };
  const hasSpecials = () => {
    return arrFilterContent.SPECIALS.htmlContainer !== '';
  };
  const hasHotels = () => {
    return arrFilterContent.HOTELAPPARTEMENT.htmlContainer !== '';
  };

  /**
   * Function to build each housing type block
   * @param {Object} item
   * @param {Object} subFilter
   */
  const buildHtmlHousing = function (item, subFilter) {
    const htmlChecked = item.selected ? ' checked="checked"' : '';
    const htmlDisabled = item.enabled || item.selected ? '' : ' u-disabled';
    const htmlDisabledClass = item.enabled ? '' : ' class="u-disabled"';
    const htmldisabledText = item.enabled ? '' : `<p class="unavailable">${wordings['facette_new_housing_unavailable_housing']}</p>`;
    const hasPhotos = typeof item.photos !== 'undefined' && item.photos !== null;
    const photoBaseUrl = hasPhotos ? GLOBAL_SCRIPTS.BASELINK_MEDIA : GLOBAL_SCRIPTS.STATIC_VERSION;
    const photoSizes = {
      mobile: '230x173',
      tablet: '362x160',
      desktop: '566x250'
    };

    // build default pictures list
    let photoList = hasPhotos ? item.photos : {
      [photoSizes.mobile]: ['/assets/images/default/' + photoSizes.mobile + '.jpg'],
      [photoSizes.tablet]: ['/assets/images/default/' + photoSizes.tablet + '.jpg'],
      [photoSizes.desktop]: ['/assets/images/default/' + photoSizes.desktop + '.jpg']
    };

    // add base url to all pictures
    $.each(photoList, (size, item) => {
      photoList[size] = photoList[size].includes(photoBaseUrl) ? photoList[size] : photoBaseUrl + photoList[size][0];
    });

    const htmlPicture = `
    <picture${htmlDisabledClass}>
      <source media="(max-width: 767px)" srcset="${photoList[photoSizes.mobile]}">
      <source media="(max-width: 1199px)" srcset="${photoList[photoSizes.tablet]}">
      <img src="${photoList[photoSizes.desktop]}" alt="${item.label}" itemprop="image" class="lazy">
      <noscript>
        <img src="${photoList[photoSizes.tablet]}" alt="${item.label}" />
      </noscript>
    </picture>`;

    // handling description
    const htmlDesc = item.desc !== null ? `<p${htmlDisabledClass}>${item.desc}</p>` : '';
    const inputId = `facette_housingcategory_${item.key}`;
    subFilter.label = item.grouping;

    // subList concatenation
    subFilter.htmlContainer += `
      <div class="searchFilters-filterBox searchFilters-filterHebergement${htmlDisabled}">
        <label for="${inputId}">
          <div class="form-checkboxContainer">
            <input name="facet[HOUSINGCATEGORY][]"
              id="${inputId}"
              value="${item.key}"
              class="form-checkbox js-filterInput"
              type="checkbox"
              data-facette="housingcategory"
              data-groupe="${item.keyGrouping}"
              ${htmlChecked}
              >
            <span class="form-checkboxLabel form-label">
              ${item.value}
            </span>
          </div>
          ${htmldisabledText}
          ${htmlPicture}
          ${htmlDesc}
        </label>
      </div>`;
  };

  /**
   * Build HTML Filter box
   * @param item
   */

  const buildHtmlFilter = function (item) {
    const htmlChecked = typeof item !== 'undefined' && item.selected !== undefined && item.selected ? ' checked="checked"' : '';
    const htmlDisabled = typeof item !== 'undefined' && item.enabled !== undefined && item.enabled ? '' : ' u-disabled';
    const key = typeof item !== 'undefined' && item.key ? item.key : '';
    const value = typeof item !== 'undefined' && item.value ? item.value : '';
    const label = value === 'PMR' ? wordings.facette_label_housingSpecPmr : value === 'ANIMALS' ? wordings.facette_label_housingSpecAnimals : value === 'RENOVATED' ? wordings.facette_label_housingSpecRenovated : '';
    const inputId = `facette_housingspecFilter_${key}`;

    if (!key) {
      return;
    }

    htmlContainerFilter += `
      <div class="searchFilters-filterItem${htmlDisabled}">
        <label for="${inputId}">
          <div class="form-checkboxContainer">
            <input name="facet[HOUSINGSPEC][]" id="${inputId}" value="${key}" class="form-checkbox js-filterInput" type="checkbox" data-facette="housingspec" ${htmlChecked}>
            <span class="form-checkboxLabel form-label">${label}</span>
          </div>
        </label>
      </div>`;
  };

  // Loop to build special filter
  if (typeof filtreSpecial !== 'undefined') {
    $.each(arrFilterSpecialContent, filterSpecialContent => {
      buildHtmlFilter(filtreSpecial.values[filterSpecialContent]);
    });
  }

  // Check if there's no data for PMR, then add a disabled checkbox
  let pmrDataExists = false;
  if (typeof filtreSpecial !== 'undefined') {
    $.each(arrFilterSpecialContent, filterSpecialContent => {
      const item = filtreSpecial.values && filtreSpecial.values[filterSpecialContent];
      if (item && item.value === 'PMR') {
        pmrDataExists = true;
      }
    });
  }

  if (!pmrDataExists) {
    htmlContainerFilter += `
      <div class="searchFilters-filterItem u-disabled">
        <label for="">
          <div class="form-checkboxContainer">
            <input name="facet[HOUSINGSPEC][]" id="" value="" class="form-checkbox js-filterInput" type="checkbox" data-facette="housingspec">
            <span class="form-checkboxLabel form-label">${wordings.facette_label_housingSpecPmr}</span>
          </div>
        </label>
      </div>`;
  }

  // Loop to build each tab content
  $.each(arrFilterContent, (i, subFilter) => {
    $.each(arrListHebergement[i], (index, item) => {
      buildHtmlHousing(item, subFilter);
    });
  });

  /**
   * Get tabs icon
   * @param {string} key
   * @return {string}
   */
  const getIcons = function (key) {
    let icon = '';

    switch (key) {
      case 'COTTAGE':
        icon = '<i class="icon icon-heberg-cottages"></i>';
        break;
      case 'SPECIALS':
        icon = '<i class="icon icon-heberg-insolites"></i>';
        break;
      case 'HOTELAPPARTEMENT':
        icon = '<i class="icon icon-heberg-appart"></i>';
        break;
    }

    return icon;
  };

  /**
   * Build link templates
   * @param {Object} item
   * @param {string} item.key - key for "arrFilterContent" object
   * @param {string} item.label - label for
   * @param {number} item.index - loop/reference index
   * @return {string}
   */
  const buildLinks = ({key, label, index}) => {
    if ((!hasHotels() && key === 'HOTELAPPARTEMENT') || (!hasSpecials() && key === 'SPECIALS')) {
      return '';
    } else {
      const isActive = label === tab;
      const classnames = `js-memorizeOpenTab searchFilters-filterAccordionItem api_accordion-itemTitle api_accordion-itemTitle--sf-${index}${isActive ? ' active' : ''}`;
      const icon = getIcons(key);

      return `<li class="${classnames}" data-index="sf-${index}" data-label="${label}">
                <span class="searchFilters-filterAccordionTitle">${icon}${arrFilterContent[key].label}</span>
            </li>`;
    }
  };

  /**
   * Build content template
   * @param {Object} item
   * @param {string} item.key - key for "arrFilterContent" object
   * @param {string} item.label - label for
   * @param {number} item.index - loop/reference index
   * @return {string}
   */
  const buildContent = ({key, label, index}) => {
    if ((!hasHotels() && key === 'HOTELAPPARTEMENT') || (!hasSpecials() && key === 'SPECIALS')) {
      return '';
    } else {
      const isActive = label === tab;
      const icon = getIcons(key);

      const mobileHeader = `<div class="searchFilters-filterAccordionItem api_accordion-itemTitle api_accordion-itemTitle--sf-${index}${isActive ? ' active' : ''} u-Visible-mobile" data-index="sf-${index}">
        <span class="searchFilters-filterAccordionTitle">${icon}${arrFilterContent[key].label}</span>
        <i class="icon arrowOpen"></i>
      </div>`;

      const facetContent = `${mobileHeader}
        <div class="searchFilters-filterAccordionContent api_accordion-itemContent api_accordion-itemContent--sf-${index}${isActive ? ' active' : ''}">${arrFilterContent[key].htmlContainer}</div>`;

      return `<div class="searchFilters-filterAccordionContainer">${facetContent}</div>`;
    }
  };

  /**
   * Gestion du bloc ouvert par défaut
   */
  const tabsDataCP = [{
    key: 'COTTAGE',
    label: 'cottage',
    index: 1
  }, {
    key: 'SPECIALS',
    label: 'specials',
    index: 2
  }, {
    key: 'HOTELAPPARTEMENT',
    label: 'hotelappartement',
    index: 3
  }];
  const tabsDataSP = [{
    key: 'MAISON',
    label: 'maison',
    index: 1
  }, {
    key: 'HOTEL',
    label: 'hotel',
    index: 2
  }];
  const isSunParks = GLOBAL_SCRIPTS.UNIVERS.toUpperCase() === 'SP';
  const tabsDataItems = isSunParks ? tabsDataSP : tabsDataCP;
  const comparePopinBtn = typeof GLOBAL_SCRIPTS.WORDINGS_COMFORT_LVL !== 'undefined' ? `<a href="#" class="searchFilters-filterLink js-dialog-open">${GLOBAL_SCRIPTS.WORDINGS_COMFORT_LVL.confort_levels_btn}</a>` : '';

  htmlFacette += `<div class="searchFilters-filterAccordion api_accordion" data-hascallback="1" data-callback="search:filters:resetBoxesHeight" data-collapsible="mobile">
  <div class="searchFilters-filterTitle" id="filter_housingcategory">${wordings.facette_label_equipments}</div>
  <div class="searchFilters-filterBoxContainer searchFilters-filterBoxContainer--special api_accordion-itemContent">${htmlContainerFilter}</div>`;

  // Complete facette concatenation
  let hasData = false;

  tabsDataItems.forEach(item => {
    if (arrListHebergement[item.key] && arrListHebergement[item.key].length > 0) {
      hasData = true;
    }
  });

  if (hasData) {
    htmlFacette += `<div class="searchFilters-filterTitle">${wordings.facette_label_housingTypes}</div>
    <ul class="searchFilters-filterAccordionList u-Hidden-mobile">`;
  }

  tabsDataItems.forEach(item => {
    if (arrListHebergement[item.key] && arrListHebergement[item.key].length > 0) {
      htmlFacette += buildLinks(item);
    }
  });

  if (hasData) {
    htmlFacette += `</ul>${comparePopinBtn}<div class="searchFilters-filterAccordionWrapper">`;
  }

  tabsDataItems.forEach(item => {
    if (arrListHebergement[item.key] && arrListHebergement[item.key].length > 0) {
      htmlFacette += buildContent(item);
    }
  });

  if (hasData) {
    htmlFacette += '</div>';
  }

  htmlFacette += '</div>';

  return htmlFacette;
};
